const nuevaPrestacionFormState = {
  aceptaGuardadoModal: false,
  codigoFonasaLoading: false,
  validarGuarismo: true,
  detallePrestacion: {
    codigoPrestacionPrestador: null,
    tipoPrestacion: null,
    pabellonPrestacion: null,
    glosaPrestacionPrestador: null,
    glosaGrupoPrestacionIsapre: null,
    inicioVigenciaArancel: null,
    pertenenciaFonasa: null,
    codigoFonasa: null,
    itemImed: null,
    tipoProfesional: null,
    tipoUnidad: null,


    grupoPrestacionIsapre: "",
    codigoPrestacionIsapre: "",
    glosaPrestacionIsapre: "",
    montoArancelPrestacion: "",
    tipoAtencion: "",

    codigoPrestacionPrestadorErr: null,
    tipoPrestacionErr: null,
    pabellonPrestacionErr: null,
    glosaPrestacionPrestadorErr: null,
    inicioVigenciaArancelErr: null,
    pertenenciaFonasaErr: null,
    codigoFonasaErr: null,
    itemImedErr: null,
    tipoProfesionalErr: null,
    tipoUnidadErr: null,
    grupoPrestacionIsapreErr: "",
    codigoPrestacionIsapreErr: "",
    glosaPrestacionIsapreErr: "",
    montoArancelPrestacionErr: "",
    tipoAtencionErr: "",

    codigoFonasaValid: null,
    codigoFonasaGlosa: "",
  },
  valorHosp: "0",
  valorAmb: "0",
  valorHospErr: "",
  valorAmbErr: "",
  prestacionesSeleccionadas: [],
  tiposArancel: [],
  centrosAtencion: [],
  tipoUnidadReplicar: null,
  valorMaxPres: [],
};

export default nuevaPrestacionFormState;
